import Route from '@ember/routing/route';
import { setProperties } from '@ember/object';
import { inject as service } from '@ember/service';

class CreatorSignupRoute extends Route {
  @service router;
  @service session;

  redirect() {
    if (!this.session.currentUser?.isSeller) {
      this.router.replaceWith('start');
    }
  }

  activate() {
    super.activate(...arguments);

    setProperties(this.controllerFor('application'), {
      simpleHeaderRightText: 'Logout',

      simpleHeaderRightAction: () => {
        this.session.invalidate();
      },
    });

    setProperties(this.controllerFor('signup.step'), {
      signupStep: this.session.currentUser.signupStep,
    });
  }

  deactivate() {
    super.deactivate(...arguments);

    this.controllerFor('application').setProperties({
      simpleHeaderRightText: '',
      simpleHeaderRightAction: null,
    });
  }
}

export default CreatorSignupRoute;
